(function () {
    'use strict';

    angular
        .module('homeControllers', ['services.supervisorService',
                                    'services.employees',
                                    'services.search',
                                    'services.accessReview',
                                    'services.systemOwnerReview']);
})();
